import React, { useEffect, useState } from 'react';
import {
    ChevronLeft,
    Plus,
} from 'react-bootstrap-icons';
import styles from './contact_relations_detai.module.css';
import { ActionButton, Avatar, Cell, Column, Flex, Grid, Link, Row, TableBody, TableHeader, TableView, View } from '@adobe/react-spectrum';
import { useTranslation } from 'react-i18next';
import { FPAData } from '../../../../../infra/protected/FPA/FPAData';
import { CloseIcon, EditIcon, GlobeIcon, MessageIcon, MoreIcon, PhoneIcon, SendIcon, TrashIcon } from '../../../Icons/IconsLib';
import { useDependency } from '../../../../../contexts/DependencyProvider';
import RelatedContexts from '../../../../../pages/protected/contacts/component/RelatedContexts';
import ContactTimelineView from '../../../../../pages/protected/contacts/component/ContactTimelineView';
import { useReefConfig } from '../../../../../hooks/UseReefConfig';
import { getDownloadUrl } from '../../../../../utils/ImagePathUtils';
import { invokeFinderApp } from '../../../../../utils/NavigationUtils';
import { DeleteConfirmationDialog } from '../../../../../pages/protected/finder/components/DeleteConfirmationDialog';
import { useViewInfo } from '../../../../../hooks/UseViewInfo';
interface IContactRelationsDetailProps {
    contact: any;
    employees: any;
    handleEmployeeClick: any;
    handleEmployerClick: any;
    isPerson: any;
    navigationStack: any;
    handleBack: () => void;
    listOrganizationFolder: any;
    contactStatusList: any;
    handleEditClick: any;
    handleContactDelete:any;
    handleAddEmployeeRelation: () => void;
    handleAddEmployerRelation: () => void;
    handleRemoveRelation: (relationId: string) => Promise<void> | void;
}
const ContactRelationsDetail: React.FC<IContactRelationsDetailProps> = ({
    contact,
    employees,
    handleEmployeeClick,
    handleEmployerClick,
    isPerson,
    navigationStack,
    handleBack,
    contactStatusList,
    listOrganizationFolder,
    handleEditClick,
    handleContactDelete,
    handleAddEmployeeRelation,
    handleAddEmployerRelation,
    handleRemoveRelation,
}) => {
    const [employeesData, setEmployeesData] = useState<any>([]);
    const [result, setResult] = useState<any>([]);
    const { t } = useTranslation(['contacts', 'layout_components']);
    const _t = (key: string) => t(`contact_detail.${key}`, { ns: 'contacts' });
    const _tc = (key: string) => t(key, { ns: 'contacts' });
    const _tl = (key: string) => t(key, { ns: 'layout_components' });
    const { store } = useDependency();
    const {isMobile} = useViewInfo();

    useEffect(() => {
        setEmployeesData(employees);
    }, [employees])

    useEffect(() => {
        const data = {
            ...contact,
            ADDRESSES: Array.isArray(contact?.ADDRESSES)
                ? contact.ADDRESSES.map((address: any) => address.ADDRESS)
                : contact?.ADDRESSES?.ADDRESS
                    ? [contact.ADDRESSES.ADDRESS]
                    : [],
            CONTACTS: Array.isArray(contact?.CONTACTS)
                ? contact.CONTACTS.map((contact: any) => contact.CONTACT)
                : contact?.CONTACTS?.CONTACT
                    ? [contact.CONTACTS.CONTACT]
                    : [],
            DGROUPS: Array.isArray(contact?.DGROUPS)
                ? contact.DGROUPS.map((contact: any) => contact.DGROUP)
                : contact?.DGROUPS?.DGROUP
                    ? [contact.DGROUPS.DGROUP]
                    : [],
            RELATIONS: Array.isArray(contact?.RELATIONS)
                ? contact.RELATIONS.map((contact: any) => contact.RELATION)
                : contact?.RELATIONS?.RELATION
                    ? [contact.RELATIONS.RELATION]
                    : [],
            FOLDERS: Array.isArray(contact?.FOLDERS)
                ? contact.FOLDERS.map((address: any) => address.FOLDER)
                : contact?.FOLDERS?.FOLDER
                    ? [contact.FOLDERS.FOLDER]
                    : [],
            EMPLOYMENTS: Array.isArray(contact?.EMPLOYMENTS)
                ? contact.EMPLOYMENTS.map((employment: any) => employment.COMPANY)
                : contact?.EMPLOYMENTS?.COMPANY
                    ? [contact.EMPLOYMENTS.COMPANY]
                    : [],
            INDUSTRIES: Array.isArray(contact?.INDUSTRIES)
                ? contact.INDUSTRIES.map((Industry: any) => Industry.INDUSTRY)
                : contact?.INDUSTRIES?.INDUSTRY
                    ? [contact.INDUSTRIES.INDUSTRY]
                    : [],
            DOCUMENT: Array.isArray(contact?.DOCUMENT)
                ? contact.DOCUMENT.map((document: any) => document)
                : contact?.DOCUMENT
                    ? [contact.DOCUMENT]
                    : [],
        };
        setResult(data)
    }, [contact])


    const handleEmployeeListClick = (id: any) => {
        const filteredEmployee = employeesData.find((x: any) => x.id === id)
        handleEmployeeClick(filteredEmployee.contact)
    }

    const handleEmployerListClick = (id: any) => {
        handleEmployerClick(id)
    }

    let [isOpen, setOpen] = React.useState(false);

    const getSelectedItm = () => {
        const selectedItem = new FPAData();
        selectedItem.id = contact?.folderId;
        return selectedItem
    }

    const { baseUrl, loginInfo } = useReefConfig();
    const getProfileUrl = () => {
        if (result.DOCUMENT && result.DOCUMENT.length > 0) {
            const imageUrl = getDownloadUrl(result.DOCUMENT[0].documentId, baseUrl, store.Server, store.SessionId);
            return imageUrl
        }
        return '/assets/images/avatar--desktop--light@2x.png'
    }

    const addStatusColor = (type: string) => {
        let customStatusName = '';
        if (!contact || !contact.FOLDERS) {
            return '';
        }
        if (!Array.isArray(contact.FOLDERS)) {
            customStatusName = contact.FOLDERS?.FOLDER?.customStateName;
        } else {
            const filteredFolder = contact.FOLDERS.find((item: any) => item.FOLDER.type === type);
            customStatusName = filteredFolder?.FOLDER?.customStateName;
        }
        if (customStatusName != '') {
            const statusObj = contactStatusList.find((obj: any) => obj.name === customStatusName);
            return statusObj?.color;
        } else {
            return ''
        }
    };

    const handleFolderClick = (folderId: any) => {
        invokeFinderApp(folderId)
    }

    return (
        <View>
            {isMobile || window.innerWidth < 1030 ?
            <>
                <Flex justifyContent={'space-between'}>
      <Flex direction={'row'} gap={'size-100'} UNSAFE_style={{paddingTop:0}}>
            {listOrganizationFolder && listOrganizationFolder.map(((folder:any)=>(
              <View key={folder.folderId} UNSAFE_className={styles.tag} UNSAFE_style={{backgroundColor:addStatusColor(folder.folderTypeId)}}>
                <View UNSAFE_className={styles.mobile}>
                  <a onClick={()=>handleFolderClick(folder.folderId)}>
                    {folder.folderTypeName}
                    </a>
                  </View>
              </View>
            )))}
          </Flex>
      <View>
            <View UNSAFE_className={styles.iconsstates1}>
              <ActionButton isQuiet onPress={()=>handleEditClick(true)}>
                <EditIcon size={20} />
              </ActionButton>
              <ActionButton isQuiet>
                <TrashIcon size={20} />
              </ActionButton>
              <ActionButton isQuiet>
                <MoreIcon size={20} />
              </ActionButton>
            </View>
          </View>
      </Flex>
      <Flex>
      <View UNSAFE_className={styles['icon-contacts-parent']}>
        {navigationStack && navigationStack.length > 0 && 
                          <ActionButton isQuiet onPress={handleBack}>
                          <ChevronLeft size={20} />
                          </ActionButton>
                        }
                  <b className={styles['adam-novotn']}><span className={
                   +contact?.folderCount > 0 ?styles.contact_icon_orange:styles.contact_icon_grey
                  }><Avatar src='/assets/images/avatar--desktop--light@2x.png' size={24} /></span> {contact.name3} {contact.name1}</b>
      </View>
      </Flex>
      </>
      :<Flex justifyContent={'space-between'}>
                <View UNSAFE_className={styles['frame-parent']}>
                    <View UNSAFE_className={styles['icon-contacts-parent']}>
                        {navigationStack && navigationStack.length > 0 &&
                            <ActionButton isQuiet onPress={handleBack}>
                                <ChevronLeft size={20} />
                            </ActionButton>
                        }
                        <b className={styles['adam-novotn']}><span className={
                            +contact?.folderCount > 0 ? styles.contact_icon_orange : styles.contact_icon_grey
                        }>
                            {/* <ContactIcon size={20} color={'#ff9800'} /> */}
                            <Avatar src={getProfileUrl()} size={26} /></span> <span style={{ fontFamily: 'Adobe Clean', fontSize: '20px', fontWeight: '700' }}>{contact?.name3} {contact?.name1}</span></b>
                    </View>
                </View>
                <Flex direction={'row'}>
                    <View UNSAFE_className={styles['tag-parent']}>
                        {listOrganizationFolder && listOrganizationFolder.map(((folder: any) => (
                            <View key={folder.folderId} UNSAFE_className={styles.tag} UNSAFE_style={{ backgroundColor: addStatusColor(folder.folderTypeId) }}>
                                <View UNSAFE_className={styles.mobile}>
                                    <a onClick={() => handleFolderClick(folder.folderId)}>
                                        {folder.folderTypeName}
                                    </a>
                                </View>
                            </View>
                        )))}
                    </View>
                    <View UNSAFE_className={styles.iconsstates2}>
                        <ActionButton isQuiet onPress={() => handleEditClick(true)}>
                            <EditIcon size={24} />
                        </ActionButton>
                        <ActionButton isQuiet onPress={() => setOpen(true)}>
                            <TrashIcon size={24} />
                        </ActionButton>
                        <ActionButton isQuiet>
                            <MoreIcon size={24} />
                        </ActionButton>
                    </View>
                </Flex>
            </Flex>
            }
            
            <Grid
                columns={{ base: ['1fr'], L: ['1fr', '1fr'] }}
                gap={{ base: 'size-150', L: 'size-200' }}
                marginTop="size-200"
            >
                <View>
                    <b className={styles.address}>{_t('contact_details')}</b>
                    <TableView
                        overflowMode="wrap"
                        density="spacious"
                        UNSAFE_className='tblContactLayoutComponent'
                        marginTop={10}
                    >
                        <TableHeader>
                            <Column width={140}>{_t('contact_type')}</Column>
                            <Column>{_t('details')}</Column>
                        </TableHeader>
                        <TableBody>
                            <Row>
                                <Cell>
                                    <div style={{ display: 'flex', alignItems: 'start' }}>
                                        <MessageIcon size={18} />
                                        <span style={{ marginLeft: '8px' }}>{_t('email')}</span>
                                    </div>
                                </Cell>
                                <Cell>
                                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '1').map((email: any, index: number) => (
                                        <div key={email.id || `email-${index}`}>
                                            {email.typeName}: <Link href={`mailto:${email.content}`}> {email.content}</Link>
                                        </div>
                                    ))}
                                </Cell>
                            </Row>
                            <Row>
                                <Cell>
                                    <div style={{ display: 'flex', alignItems: 'start' }}>
                                        <PhoneIcon size={18} />
                                        <span style={{ marginLeft: '8px' }}>{_t('phone')}</span>
                                    </div>
                                </Cell>
                                <Cell>
                                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '3' || x.typeType === '2' || x.typeType
                                        === '4').map((phone: any, index: number) => (
                                            <div key={phone.id || `phone-${index}`}>
                                                {phone.typeName}: <Link href={`tel:${phone.content}`}> {phone.content}</Link>
                                            </div>
                                        ))}
                                </Cell>
                            </Row>
                            <Row>
                                <Cell>
                                    <div style={{ display: 'flex', alignItems: 'start' }}>
                                        <GlobeIcon size={18} />
                                        <span style={{ marginLeft: '8px' }}>{_t('web')}</span>
                                    </div>
                                </Cell>
                                <Cell>
                                    <div>
                                        {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '5').map((phone: any, index: number) => (
                                            <div key={phone.id || `web-${index}`}>
                                                {phone.typeName}: <Link href={phone.content && phone.content.startsWith('http') ? phone.content : `https://${phone.content}`} target="_blank" rel="noopener noreferrer">{phone.content}</Link>
                                            </div>
                                        ))}
                                    </div>
                                </Cell>
                            </Row>
                            <Row>
                                <Cell>
                                    <div style={{ display: 'flex', alignItems: 'start' }}>
                                        <SendIcon size={18} />
                                        <span style={{ marginLeft: '8px' }}>{_t('social_media')}</span>
                                    </div>
                                </Cell>
                                <Cell>
                                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '9' || x.typeType === '10' || x.typeType
                                        === '11').map((phone: any, index: number) => (
                                            <div key={phone.id || `social-${index}`}>
                                                {phone.typeName}: <Link href={phone.content && phone.content.startsWith('http') ? phone.content : `https://${phone.content}`} target="_blank" rel="noopener noreferrer">{phone.content}</Link>
                                            </div>
                                        ))}
                                </Cell>
                            </Row>
                        </TableBody>
                    </TableView>
                    {result && result.ADDRESSES && result.ADDRESSES.length > 0 &&
                        <View marginTop={15} UNSAFE_className={styles['address-parent']}>
                            <b className={styles.address}>{_t('address')}</b>
                            <View UNSAFE_className={styles['value-wrapper']}>
                                <View UNSAFE_className={styles.addressValue}>
                                    <p className={styles.bristol}>{result.ADDRESSES[0].street}</p>
                                    <p className={styles.bristol}>{result.ADDRESSES[0].cityName}</p>
                                    <p className={styles.bristol}>{result.ADDRESSES[0].zipName}</p>
                                </View>
                            </View>
                        </View>
                    }
                    {employeesData && !isPerson &&
                        <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
                            <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                                <View UNSAFE_className={styles.address}><b>{_t('employees')}</b></View>
                                <Flex>
                                    <ActionButton isQuiet aria-label={_tl('add')} onPress={handleAddEmployeeRelation}>
                                        <Plus size={20} />
                                    </ActionButton>
                                </Flex>
                            </Flex>
                            <View UNSAFE_className={styles['value-wrapper']}>
                                <View UNSAFE_className={styles.value}>
                                    {employeesData.map((employee: any, index: number) => ((
                                        <Flex key={employee.id || `employee-${index}`} marginBottom={10} direction={'row'} alignItems="center" justifyContent="space-between" gap={'size-100'} width="100%">
                                            <Flex direction="column" gap="size-50" flex="1" minWidth="0">
                                                <View UNSAFE_className={styles["employee-name"]}>
                                                    <Link isQuiet onPress={() => handleEmployeeListClick(employee.id)}>{`${employee.name3} ${employee.name1}`}</Link>
                                                </View>
                                                <View UNSAFE_className={styles["employee-details"]}>
                                                    {employee.departmentName && ' | '}
                                                    {employee.positionName}
                                                    {employee.departmentName && ` (${employee.departmentName})`}
                                                </View>
                                            </Flex>
                                            <ActionButton
                                                isQuiet
                                                aria-label={_tc('remove_employee')}
                                                onPress={() => handleRemoveRelation(employee.id)}
                                                isDisabled={!employee?.id}
                                            >
                                                <CloseIcon size={14} />
                                            </ActionButton>
                                        </Flex>
                                    )))}
                                </View>
                            </View>
                        </View>
                    }
                    {employeesData && isPerson &&
                        <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
                            <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                                <View UNSAFE_className={styles.address}><b>{_t('employers')}</b></View>
                                <Flex gap="size-100">
                                    <ActionButton isQuiet aria-label={_tl('add')} onPress={handleAddEmployerRelation}>
                                        <Plus size={20} />
                                    </ActionButton>
                                </Flex>
                            </Flex>
                            <View UNSAFE_className={styles['value-wrapper']}>
                                <View UNSAFE_className={styles.value}>
                                    {result && result.EMPLOYMENTS?.map((employee: any, index: number) => (
                                        <Flex key={employee.id || `employer-${index}`} marginBottom={10} direction={'row'} alignItems="center" justifyContent="space-between" gap={'size-100'} width="100%">
                                            <Flex direction="column" gap="size-50" flex="1" minWidth="0">
                                                <View UNSAFE_className={styles["employee-name"]}>
                                                    <Link isQuiet onPress={() => handleEmployerListClick(employee.id)}>{`${employee.name}`}</Link>
                                                </View>
                                                <View UNSAFE_className={styles["employee-details"]}>
                                                    {employee.positionInfo} {employee.departmentName && ' | '}
                                                    {employee.positionName}
                                                    {employee.departmentName && ' | '}
                                                    {employee.departmentName}
                                                </View>
                                            </Flex>
                                            <ActionButton
                                                isQuiet
                                                aria-label={_tc('remove_employer')}
                                                onPress={() => handleRemoveRelation(employee.id)}
                                                isDisabled={!employee?.id}
                                            >
                                                <CloseIcon size={14} />
                                            </ActionButton>
                                        </Flex>
                                    ))}
                                </View>
                            </View>
                        </View>
                    }
                    {contact && result && result.RELATIONS?.length > 0 &&
                        <View marginTop={10} UNSAFE_className={styles['greybox-parent']}>
                            <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                                <View UNSAFE_className={styles.address}><b className={styles.address}>{_t('related_companies')}</b></View>
                                <Flex gap="size-100">
                                    <ActionButton isQuiet aria-label={_tl('add')}>
                                        <Plus size={20} />
                                    </ActionButton>
                                </Flex>
                            </Flex>
                            <View UNSAFE_className={styles['value-wrapper']}>
                                <View UNSAFE_className={styles.value}>
                                    {result.RELATIONS.flat()
                                        .filter((relation: any) => relation != null)
                                        .map((relation: any) => {
                                            const isMainCompanyContact1 = relation.contact1Id === contact?.id;
                                            const isMainCompanyContact2 = relation.contact2Id === contact?.id;

                                            if (!isMainCompanyContact1 && !isMainCompanyContact2) return null;

                                            const relatedCompany = isMainCompanyContact1
                                                ? { id: relation.contact2Id, name: relation.contact2Name1, type: relation.typeName2 }
                                                : { id: relation.contact1Id, name: relation.contact1Name1, type: relation.typeName1 };

                                            if (!relatedCompany?.id) return null;

                                            return (
                                                <Flex marginBottom={10} direction={'row'} gap={'size-100'} key={relatedCompany.id}>
                                                    <View UNSAFE_className={styles["employee-details"]}>
                                                        <Link isQuiet onPress={() => handleEmployerListClick(relatedCompany.id)}>
                                                            {relatedCompany.name}
                                                        </Link>
                                                        {relatedCompany.type && ' | '}
                                                        {relatedCompany.type}
                                                    </View>
                                                </Flex>
                                            );
                                        })}

                                </View>
                            </View>
                        </View>
                    }
                    <RelatedContexts contact={contact} />
                </View>
                <View flex>
                    <ContactTimelineView contactId={contact?.id} selectedItem={getSelectedItm()} contactStatusList={contactStatusList} />
                </View>
            </Grid>
            <DeleteConfirmationDialog
                          isOpen={isOpen}
                          onClose={() => setOpen(false)}
                          onConfirm={()=>handleContactDelete(contact)}
                          itemName={contact?.name1}
                        />
        </View>
    );
};

export default ContactRelationsDetail;
